import { Code } from '@tiptap/extension-code';

const CodeExtensionWithKeyboardShortcuts = Code.extend({
  addKeyboardShortcuts() {
    return {
      'Cmd-Shift-C': () => {
        this.editor.chain().focus().toggleCode().run();
        return true;
      },
      'Ctrl-Shift-C': () => {
        this.editor.chain().focus().toggleCode().run();
        return true;
      }
    };
  }
});

export default CodeExtensionWithKeyboardShortcuts;
